"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const getElasticsearchQueryFromFilters_1 = require("./getElasticsearchQueryFromFilters");
const getElasticsearchQueryFromSearch_1 = require("./getElasticsearchQueryFromSearch");
function getElasticsearchQueryFromFiltersAndSearch(filters, searchMatchConfig) {
    let filterQuery = {};
    if (filters) {
        filterQuery = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters);
        if (!searchMatchConfig) {
            return filterQuery;
        }
    }
    let searchQuery = {};
    if (searchMatchConfig) {
        searchQuery = getElasticsearchQueryFromSearch_1.getElasticsearchQueryForSearch(searchMatchConfig);
        if (Object.keys(filterQuery).length === 0) {
            return searchQuery;
        }
    }
    // merging different bools
    const finalQuery = { bool: {} };
    const keys = uniq_1.default(Object.keys(filterQuery.bool).concat(Object.keys(searchQuery.bool)));
    keys.forEach(key => {
        if (Array.isArray(filterQuery.bool[key])) {
            finalQuery.bool[key] = [...(searchQuery.bool[key] || []), ...(filterQuery.bool[key] || [])];
        }
        else {
            finalQuery.bool[key] = filterQuery.bool[key] || searchQuery.bool[key];
        }
    });
    return finalQuery;
}
exports.getElasticsearchQueryFromFiltersAndSearch = getElasticsearchQueryFromFiltersAndSearch;
//# sourceMappingURL=index.js.map